class RpcLoggerFactory {
  _nextId;
  _requestLoggerClass;
  constructor(requestLoggerClass) {
    this._nextId = 0;
    this._requestLoggerClass = requestLoggerClass;
  }
  build() {
    return new this._requestLoggerClass(this._nextId++);
  }
}
const COLORS = [
  "#F44336",
  // red
  "#E91E63",
  // pink
  "#9C27B0",
  // purple
  "#673AB7",
  // deep purple
  "#3F51B5",
  // indigo
  "#2196F3",
  // blue
  "#03A9F4",
  // light blue
  "#00BCD4",
  // cyan
  "#009688",
  // teal
  "#4CAF50",
  // green
  "#8BC34A",
  // light green
  "#CDDC39",
  // lime
  "#FFEB3B",
  // yellow
  "#FFC107",
  // amber
  "#FF9800",
  // orange
  "#FF5722",
  // deep orange
  "#795548",
  // brown
  "#9E9E9E",
  // grey
  "#607D8B"
  // blue grey
];
class ConsoleRequestLogger {
  colors;
  console;
  id;
  constructor(id, colors, console = globalThis.console) {
    this.id = id;
    this.colors = colors || COLORS;
    this.console = console;
  }
  getColor() {
    return this.colors[this.id % this.colors.length];
  }
  logRequest(url, requestData) {
    this.console.groupCollapsed(
      `%cRPC#${this.id} \u2191 %c${url}`,
      "color:blue",
      `color:${this.getColor()}`
    );
    this.console.log(requestData);
    this.console.groupEnd();
  }
  logResponse(url, responseData) {
    this.console.groupCollapsed(
      `%cRPC#${this.id} \u2193 %c${url}`,
      "color:green",
      `color:${this.getColor()}`
    );
    this.console.log(responseData);
    this.console.groupEnd();
  }
  logError(url, _error) {
    this.console.groupCollapsed(
      `%cRPC#${this.id} \u2193 %c${url}`,
      "color:red",
      `color:${this.getColor()}`
    );
    this.console.log(_error);
    this.console.groupEnd();
  }
}
class SilentRequestLogger {
  id;
  constructor(id) {
    this.id = id;
  }
  logRequest() {
  }
  logResponse() {
  }
  logError() {
  }
}
class ConsoleLoggerFactory extends RpcLoggerFactory {
  constructor(enabled) {
    super(enabled ? ConsoleRequestLogger : SilentRequestLogger);
  }
}

function parseResponse(response) {
  return response.arrayBuffer().then((arrayBuffer) => new Uint8Array(arrayBuffer));
}

class ConnectError extends Error {
  message;
  protoMessage;
  rawResponse;
  constructor(response, protoMessage, message) {
    super();
    this.message = ConnectError.generateMessage(
      response,
      protoMessage,
      message
    );
    this.protoMessage = protoMessage;
    this.rawResponse = response;
  }
  static generateMessage(response, protoMessage, stringMessage) {
    const message = protoMessage && protoMessage.errors ? `protoResponse includes ${protoMessage.errors.length} errors` : stringMessage ?? "no message";
    const statusString = [response.status, response.statusText].filter(Boolean).join(" ");
    return `response failed for ${response.url} (status=${statusString}): ${message}`;
  }
  static fromResponse(response, rpcMethod) {
    if (response.status < 400) {
      return new Promise((resolve) => resolve(response));
    }
    if (response.headers.get("content-type") === "application/x-protobuf") {
      return parseResponse(response).then((responseData) => {
        let protoMessage = null;
        try {
          protoMessage = rpcMethod.decode(responseData);
        } catch (error) {
          throw new ConnectError(response, null, String(error));
        }
        throw new ConnectError(response, protoMessage, null);
      });
    }
    return response.text().then((text) => {
      throw new ConnectError(response, null, text);
    });
  }
}

const characters = "ABCDEFGHJKMNPQRSTVWXYZabcdefghjk";
function generateSpeleoId() {
  return [
    ...Array.from({ length: 13 }, () => characters[Math.floor(Math.random() * characters.length)])
  ].join("");
}

export { ConsoleRequestLogger as C, RpcLoggerFactory as R, SilentRequestLogger as S, ConnectError as a, ConsoleLoggerFactory as b, generateSpeleoId as g, parseResponse as p };
